import { render } from "./ClientSpaceCountdown.vue?vue&type=template&id=1b5cdad0&scoped=true"
import script from "./ClientSpaceCountdown.vue?vue&type=script&lang=js"
export * from "./ClientSpaceCountdown.vue?vue&type=script&lang=js"

import "@/assets/scss/_clientSpaceCountdown.scss?vue&type=style&index=0&id=1b5cdad0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cdad0"]])

export default __exports__